export default "<ng-content></ng-content>"